// extracted by mini-css-extract-plugin
module.exports = {"composer__action":"composer__action__2ZuQd"};